export var IdentificationMethod;
(function (IdentificationMethod) {
    IdentificationMethod["Manual"] = "manual";
    IdentificationMethod["BankId"] = "bank-id";
    IdentificationMethod["CreditAssessment"] = "credit-assessment";
})(IdentificationMethod || (IdentificationMethod = {}));
